










import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import FormEmailEdit from "@/components/forms/FormEmailEdit.vue";
import Footer from "@/components/Footer.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    FormEmailEdit,
    Footer,
  },
})
export default class ORegisterEmailEdit extends CheckOrganizationAdminLogin {}
